<template>
  <div class="detail">
    <div class="button_list flex_between">
      <div class="flex_center" style="cursor:pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        咨询工单详情
      </div>
      <div>
        <el-button
          size="small"
          v-show="seekInfo.status == 0"
          type="success"
          @click="handleConfirmSeek"
          >确认受理</el-button
        >
        <el-button
          size="small"
          v-show="seekInfo.status == 0 || seekInfo.status == 1"
          type="danger"
          @click="handleCloseSeek"
          >关闭咨询</el-button
        >
        <!-- <el-button size="small" type="primary">导出工单</el-button> -->
        <el-button size="small" type="primary" @click="back"
          >返回列表</el-button
        >
      </div>
    </div>

    <!-- <div class="header flex_between">
      <p>咨询详情</p>
      <div></div>
      <p>
        <i class="el-icon-s-opportunity"></i> 状态:{{
          getSeekStatus(this.seekInfo.status)
        }}
      </p>
    </div> -->
    <div class="seek_content">
      <el-form disabled :inline="true" :model="seekInfo" label-width="170px">
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            工单基本信息
          </div>
          <p>
            <i class="el-icon-s-opportunity"></i> 状态:{{
              getSeekStatus(this.seekInfo.status)
            }}
          </p>
        </div>
        <div class="form-container">
          <el-form-item label="咨询主题:">
            <el-input v-model="seekInfo.consultSubject"></el-input>
          </el-form-item>
          <el-form-item label="国家:">
            <el-select
              filterable
              clearable
              v-model="seekInfo.customerCountry"
              placeholder="请选择"
            >
              <el-option
                v-for="item in nationList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发生日期:" required>
            <el-input v-model="seekInfo.happenDate"></el-input>
            <!-- <el-date-picker type="date" placeholder="选择日期" v-model="seekInfo.date1" ></el-date-picker> -->
          </el-form-item>
          <el-form-item label="报修日期:" required>
            <el-input v-model="seekInfo.repairsDate"></el-input>
            <!-- <el-date-picker type="date" placeholder="选择日期" v-model="seekInfo.date2" ></el-date-picker> -->
          </el-form-item>
          <el-form-item label="数量:">
            <el-input v-model="seekInfo.carCount"></el-input>
          </el-form-item>
          <el-form-item label="发生地点:">
            <el-input v-model="seekInfo.happenPlace"></el-input>
          </el-form-item>

          <el-form-item label="车辆属性:">
            <!-- <el-checkbox-group v-model="seekInfo.carAttributes">
                     <el-checkbox label="商品车" name="1"></el-checkbox>
                     <el-checkbox label="客户车" name="type"></el-checkbox>
                     <el-checkbox label="家用" name="2"></el-checkbox>
                     <el-checkbox label="非家用" name="3"></el-checkbox>
                     </el-checkbox-group> -->
            <el-radio-group
              v-model="seekInfo.carAttributes"
              class="radio-group"
            >
              <el-radio
                v-for="(item, index) in carAttr"
                :key="index"
                :label="item.label"
                >{{ item.name }}</el-radio
              >
              <!-- <el-radio label=2>客户车</el-radio>
                    <el-radio label=3>非家用客户车</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="行驶里程:" prop="mileage">
            <el-input placeholder="请输入里程" v-model="seekInfo.roadHaul">
              <template slot="append">km</template>
            </el-input>
          </el-form-item>
          <el-form-item label="疑似/祸首件代码:" prop="code">
            <el-input v-model="seekInfo.suspectedCulpritCode"></el-input>
          </el-form-item>
          <el-form-item label="疑似/祸首件名称:">
            <el-input v-model="seekInfo.suspectedCulpritName"></el-input>
          </el-form-item>
          <!-- <el-form-item label="疑似/祸首件供应商代码:" prop="code">
            <el-input
              v-model="seekInfo.suspectedCulpritSupplierCode"
            ></el-input>
          </el-form-item> -->
        </div>
        <!-- <el-divider content-position="left">车辆基本信息</el-divider> -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            车辆基本信息
          </div>
        </div>
        <div class="form-container">
          <el-form-item label="VIN码:">
            <el-input v-model="seekInfo.vin"></el-input>
          </el-form-item>
          <el-form-item label="车辆颜色:">
            <el-input v-model="seekInfo.carColor" disabled></el-input>
          </el-form-item>
          <el-form-item label="品牌:">
            <el-input v-model="seekInfo.carBrand" disabled></el-input>
          </el-form-item>
          <el-form-item label="车型:">
            <el-input v-model="seekInfo.carModel" disabled></el-input>
          </el-form-item>
          <el-form-item label="生产日期:">
            <el-input v-model="seekInfo.productionDate" disabled></el-input>
          </el-form-item>
          <el-form-item label="购车日期:">
            <el-input v-model="seekInfo.salesDate" disabled></el-input>
          </el-form-item>
          <el-form-item label="发动机型号:">
            <el-input v-model="seekInfo.engineModel" disabled></el-input>
          </el-form-item>
          <el-form-item label="发动机号:">
            <el-input v-model="seekInfo.engineNumber" disabled></el-input>
          </el-form-item>
        </div>
        <!-- <el-divider content-position="left">车辆保养信息</el-divider> -->

        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            车辆保养信息
          </div>
        </div>
        <div class="form-container">
          <div v-for="(item, index) in seekInfo.intervalList" :key="index">
            <el-form-item :label="intervalNameList[index] + '保日期'">
              <el-date-picker
                value-format="yyyy-MM-dd"
                type="date"
                placeholder=""
                v-model="seekInfo.intervalList[index].insuranceDate"
                style="width: 250px"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="intervalNameList[index] + '保里程'">
              <el-input
                type="number"
                v-model="seekInfo.intervalList[index].insuranceMileage"
              >
                <template slot="append">km</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="intervalNameList[index] + '保项目'">
              <el-input
                v-model="seekInfo.intervalList[index].insuranceProject"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <!-- <el-divider content-position="left">车辆故障描述</el-divider> -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            车辆故障描述
          </div>
        </div>

        <div class="form-container form-row">
          <el-form-item label="行驶工况:" prop="type" label-width="75px">
            <mycheck name="减速" :checked="seekInfo.speedDown" />
            <mycheck name="制动" :checked="seekInfo.braking" />
            <mycheck name="转向" :checked="seekInfo.steer" />
            <el-form-item label="档位:" prop="type" label-width="unset">
              <el-input v-model="seekInfo.gearValue"></el-input>
            </el-form-item>
            <el-form-item label="行驶车速" prop="type" label-width="unset">
              <el-input v-model="seekInfo.drivingSpeedValue">
                <template slot="append">km/h</template></el-input
              >
            </el-form-item>
            <el-form-item label="发动机转速" prop="type" label-width="unset">
              <el-input v-model="seekInfo.engineSpeedValue">
                <template slot="append">r/min</template></el-input
              >
            </el-form-item>
          </el-form-item>
        </div>
        <div class="form-container form-row">
          <el-form-item label="路面类型:" prop="type" label-width="75px">
            <mycheck name="水泥路" :checked="seekInfo.concreteRoad" />
            <mycheck name="沥青路" :checked="seekInfo.asphaltRoad" />
            <mycheck name="土路" :checked="seekInfo.dirtRoad" />
            <mycheck name="砂石路" :checked="seekInfo.gravelRoad" />
            <mycheck name="煤渣路" :checked="seekInfo.coalSlagRoad" />
          </el-form-item>
        </div>
        <div class="form-container form-row">
          <el-form-item label="路面状况:" prop="type" label-width="75px">
            <mycheck name="凹凸" :checked="seekInfo.uneven" />
            <mycheck name="平坦" :checked="seekInfo.flat" />
            <mycheck name="上坡" :checked="seekInfo.uphill" />
            <mycheck name="下坡" :checked="seekInfo.downhill" />
          </el-form-item>
        </div>
        <div class="form-container form-row">
          <el-form-item label="行驶路况:" prop="type" label-width="75px">
            <mycheck name="积水" :checked="seekInfo.standingWater" />
            <mycheck name="结冰" :checked="seekInfo.freeze" />
            <mycheck name="其他" :checked="seekInfo.roadConditionsOther" />
            <el-form-item prop="type">
              <el-input v-model="seekInfo.roadConditionsOtherValue"></el-input>
            </el-form-item>
          </el-form-item>
        </div>
        <div class="form-container form-row">
          <el-form-item label="天气情况:" prop="type" label-width="75px">
            <mycheck name="晴天" :checked="seekInfo.clearDay" />
            <mycheck name="下雨" :checked="seekInfo.rain" />
            <mycheck name="大雪" :checked="seekInfo.heavySnow" />
            <mycheck name="大风" :checked="seekInfo.strongWind" />
            <mycheck name="其他" :checked="seekInfo.weatherConditionsOther" />
          </el-form-item>
          <el-form-item prop="type">
            <el-input v-model="seekInfo.weatherConditionsOtherValue"></el-input>
          </el-form-item>
        </div>

        <div class="form-container form-row">
          <el-form-item label="载客人数:" prop="type" label-width="75px">
            <el-input v-model="seekInfo.passengerCapacity">
              <template slot="append">kg</template></el-input
            >
          </el-form-item>
        </div>
        <div class="form-container form-row">
          <el-form-item label="载客重量:" prop="type" label-width="75px">
            <el-input v-model="seekInfo.cargoWeight">
              <template slot="append">kg</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="form-container">
          <el-form-item label="更多描述:" prop="type">
            <el-input
              type="textarea"
              v-model="seekInfo.moreDescription"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-container">
          <el-form-item label="附件描述:">
            <div class="file">
              <div
                class="file-list"
                style="cursor: pointer;"
                v-for="(data, idx) in seekInfo.fileList"
                :key="idx"
              >
                <div class="left">
                  <i class="el-icon-document"></i
                  ><span>{{ data.fileName }}</span>
                </div>
                <div class="down-icon" v-if="data.downStatus">已下载</div>
                <div class="right" @click="downLoad(data.filePath, idx)">
                  下载
                </div>
                <div
                  class="right"
                  style="margin-left: 10px;"
                  v-if="showViewBtn(data.fileType)"
                  @click="viewFile(data)"
                >
                  预览
                </div>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- <div
      v-show="seekInfo.recordList && seekInfo.recordList.length > 0"
      class="header flex_between"
    >
      <p>咨询记录</p>
    </div> -->
    <div
      v-show="seekInfo.recordList && seekInfo.recordList.length > 0"
      class="hearder-title"
    >
      <div class="flex_between">
        <img class="title-icon" src="@/assets/img/title-icon.svg" alt="dark" />
        咨询记录
      </div>
    </div>
    <div class="record" :class="isRecord ? 'record_border' : ''">
      <div
        v-show="isRecord"
        v-for="(item, index) in seekInfo.recordList"
        :key="index"
        class="customer_service_box flex_only_center"
      >
        <div class="customer_header flex_center">
          <div class="left off" v-if="item.replyType == 1">
            <i class="el-icon-service"></i>
          </div>
          <div class="left" v-if="item.replyType == 0">
            <!-- <i class="el-icon-user-solid"></i> -->
            <div v-if="item.customerIcon == ''" class="cus">
              <i class="el-icon-user-solid"></i>
            </div>
            <div v-else class="user_avatar">
              <img :src="item.customerIcon" alt="" />
            </div>
          </div>
          <div class="right">
            <p class="offname" v-if="item.replyType == 1">官方客服</p>
            <p class="cusname" v-if="item.replyType == 0">
              {{ item.customerName }}
            </p>
            <span :class="item.replyType == 0 ? 'cusname' : 'offname'">{{
              item.createTime
            }}</span>
          </div>
        </div>
        <div :class="item.replyType == 1 ? 'offname' : 'cuscontent'">
          {{ item.replyContent }}
        </div>
        <div class="file">
          <div
            class="file-list"
            style="cursor: pointer;"
            v-for="(data, idx) in item.fileList"
            :key="idx"
          >
            <div class="left">
              <i class="el-icon-document"></i><span>{{ data.fileName }}</span>
            </div>
            <div class="right" @click="downLoad(data.filePath)">
              下载
            </div>
          </div>
        </div>
        <div v-if="item.replyType == 1">
          <translateForm
            :from="'zh-CHS'"
            :to="'en'"
            :defaultText="item.replyContent"
            :showInput="false"
            :showText="true"
          ></translateForm>
        </div>
        <div v-if="item.replyType == 0">
          <translateForm
            :from="'en'"
            :to="'zh-CHS'"
            :defaultText="item.replyContent"
            :showInput="false"
            :showText="true"
          ></translateForm>
        </div>

        <el-divider></el-divider>
      </div>
      <div
        v-show="
          seekInfo.status == 1 &&
            ((seekInfo.recordList && seekInfo.recordList.length === 0) ||
              seekInfo.recordList[seekInfo.recordList.length - 1].replyType ===
                0)
        "
      >
        <!-- <div class="header flex_between">
          <p><i class="el-icon-s-comment"></i> 编辑回复内容</p>
        </div> -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            编辑回复内容
          </div>
        </div>
        <translateForm
          @getTxt="getData"
          :from="'zh-CHS'"
          :to="'en'"
          :max="500"
          :showInput="true"
          @getInputVal="getInput"
        >
          <div class="flex">
            <el-upload
              class="upload-demo flex"
              :headers="header"
              :action="seekAction"
              ref="uploadFile"
              :on-remove="handleRemove"
              :on-success="handleFileSuccess"
              :before-upload="beforeFileUpload"
              multiple
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <el-button
              @click="replyCustomer"
              style="height:30px;margin-left:10px;"
              size="small"
              type="primary"
              >提交回复内容</el-button
            >
          </div>
        </translateForm>
      </div>
    </div>
    <view-img-video ref="viewRef"  :list="previewList"/>
  </div>
</template>
<script>
import mycheck from "@/components/mycheck";
import { seekReply, seekStatus, seekUpload } from "@/api/seek";
import TranslateForm from "@/components/translateForm";
import { getStorage } from "@/util/localStor";
import { uploadUrl } from "@/util/url";
import { getSession } from "@/util/localStor";
import ViewImgVideo from "@/components/viewImgVideo.vue";

export default {
  data() {
    return {
      previewList:[],
      header: {
        satoken: sessionStorage.getItem("token")
      },
      // seekAction:'/api/manage/quality/upload',
      seekAction: uploadUrl + "/manage/quality/upload",
      // seekAction:'http://43.157.63.49:8186/manage/quality/upload',
      //
      seekInfo: {},
      fileList: [],
      translatedText: "",
      translatedTextCus: "",
      fileList2: [],
      carAttr: [
        {
          label: 1,
          name: "商品车"
        },
        {
          label: 2,
          name: "客户车"
        },
        {
          label: 3,
          name: "非家用客户车"
        }
      ],
      yesOrNo: [
        {
          label: 1,
          name: "是"
        },
        {
          label: 0,
          name: "否"
        }
      ],
      isRecord: false,
      iptContent: "",
      cusFileList: [],
      nationList: [],
      intervalNameList: [
        "首",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五",
        "十六",
        "十七",
        "十八",
        "十九",
        "二十"
      ]
    };
  },
  components: {
    TranslateForm,
    mycheck,
    ViewImgVideo
  },
  mounted() {
    this.nationList = Object.values(getSession("nationList"));
    this.seekInfo = getStorage("seekData");
    this.previewList = this.seekInfo.fileList?.filter(item=>{
      return 'image,video'.indexOf(item.fileType.slice(0,5)) !== -1
    })
    if (this.seekInfo.recordList) {
      this.seekInfo.recordList.length > 0
        ? (this.isRecord = true)
        : (this.isRecord = false);
    }
  },
  methods: {
    getData(val) {
      this.translatedText = val;
    },
    beforeFileUpload(file) {
      let total = 0;
      total = this.sum + file.size / 1024 / 1024;
      if (total >= this.max) {
        this.$DonMessage.warning("上传该文件将超过200M，上传失败");
        return false;
      }
      const imgLt = 5;
      const videoLt = 500;
      const xlsLt = 10;
      const docLt = 10;
      let limit = 0;
      let isLt = 0;
      // 图片
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSvg = file.type === "image/svg+xml";
      let isImg = false;
      if (isJPG || isPNG || isSvg) {
        isImg = true;
      }
      if (isImg) {
        limit = imgLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning("上传图片大小不能超过 5MB!");
        }
        return isImg && isLt;
      }

      // 视频
      const isMP4 = file.type === "video/mp4";
      const is3GP = file.type === "video/3gpp";
      const isMOV = file.type === "video/quicktime";
      const isM4V = file.type === "";
      let isVideo = false;
      if (isMP4 || is3GP || isMOV) {
        isVideo = true;
      }
      if (isVideo) {
        limit = videoLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning("上传视频大小不能超过 500MB!");
        }
        return isVideo && isLt;
      }

      // 表格
      const isXLS =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (isXLS) {
        limit = xlsLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning("上传表格大小不能超过 10MB!");
        }
        return isXLS && isLt;
      }

      // 文档
      const isDOC = file.type === "application/msword";
      const isDOCX =
        file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const isPDF = file.type === "application/pdf";
      let isFile = false;
      if (isDOC || isDOCX || isPDF) {
        isFile = true;
      }
      if (isFile) {
        limit = docLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning("上传文档大小不能超过 10MB!");
        }
        return isFile && isLt;
      }
    },
    getIndex(i) {
      this.i = i;
    },
    // 点击确认受理
    handleConfirmSeek() {
      // this.seekInfo.status=1
      this.handleStatus(1);
    },
    handleFileSuccess(res, file) {
      if (res.status == 0) {
        let data = res.data;
        let obj = {
          uploadFileId: data.uploadFileId,
          // dataId: data.dataId,
          uploaderId: data.uploaderId,
          fileName: data.fileName,
          fileSize: data.fileSize,
          fileType: data.fileType,
          filePath: data.filePath,
          fileSource: data.fileSource
        };

        this.cusFileList.push(obj);
      } else {
        this.$DonMessage.error(res.message);
        let uid = file.uid; // 关键作用代码，去除文件列表失败文件
        let idx = this.$refs.uploadFile.uploadFiles.findIndex(
          item => item.uid === uid
        );
        this.$refs.uploadFile.uploadFiles.splice(idx, 1);
      }
    },
    getInput(iptVal) {
      this.iptContent = iptVal;
    },
    // 回复客户
    replyCustomer() {
      this.$confirm("确定提交回复内容?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // this.loading = true
        if (this.iptContent.trim() == "") {
          this.$DonMessage.warning("输入回复内容后再进行提交");
          return;
        } else {
          this.submitReply();
        }
      });
    },
    // 下载
    downLoad(url, index) {
      if (index === 0 || index) {
        this.$set(this.seekInfo.fileList[index], "downStatus", true);
      }
      window.open(url);
    },
    showViewBtn(type) {
      const fileExtension = type.slice(0,5) 
      return 'image,video'.indexOf(fileExtension) !== -1
    },
    // 预览
    viewFile(data) {
      this.$refs.viewRef.init(data);
    },
    back() {
      this.$router.go(-1);
    },
    getSeekStatus(data) {
      let status;
      if (data == 0) status = "待受理";
      if (data == 1) status = "受理中";
      if (data == 2) status = "已关闭";
      if (data == 3) status = "已取消";
      return status;
    },
    handleCloseSeek() {
      this.$confirm("关闭咨询后，客户将不能再回复此问题。", "确定关闭咨询?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.handleStatus(2);
      });
    },

    handleRemove(file, fileList) {
      this.cusFileList.forEach((element, index) => {
        if (file.response.data.uploadFileId == element.uploadFileId) {
          this.cusFileList.splice(index, 1);
        }
      });
    },

    // 提交回复内容
    async submitReply() {
      let content;
      if (this.translatedText == "") {
        content = this.iptContent;
      } else {
        content = this.translatedText;
      }
      if (this.cusFileList.length == 0) {
        this.cusFileList = [
          {
            uploadFileId: "",
            uploaderId: "",
            fileName: "",
            fileSize: "",
            fileType: "",
            filePath: "",
            fileSource: ""
          }
        ];
      }
      let query = {
        data: {
          qualityInquiryFormId: this.seekInfo.qualityInquiryFormId,
          customerId: this.seekInfo.customerId,
          replyContent: content,
          fileList: [...this.cusFileList]
        }
      };
      // return
      const res = await seekReply(query);
      if (res.status == 0) {
        this.$DonMessage.success("已成功提交回复");
        this.$router.go(-1);
      } else {
        this.$DonMessage.error(res.message);
      }
    },
    // 修改咨询单状态
    async handleStatus(status) {
      let query = {
        data: {
          qualityInquiryFormId: this.seekInfo.qualityInquiryFormId,
          status: status
        }
      };
      const res = await seekStatus(query);
      if (res.status == 0) {
        this.seekInfo.status = status;
      } else {
        this.$DonMessage.error(res.message);
      }
    }
  }
};
</script>
<style lang="scss" scoped>

.detail {
  box-sizing: border-box;
  .button_list {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: #fff;
    top: -12px !important;
    margin-top: -12px;
    width: calc(100% + 30px);
    margin-left: -15px;
    padding: 6px 32px 6px 14px !important;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    margin-bottom: 34px;
    .title-icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
}
.header {
  width: 100%;
  padding: 5px 10px;
  background: #e9f3ff;
  margin: 10px 0;
  box-sizing: border-box;
  p {
    font-size: 16px;
    color: #4095e5;
    font-weight: bold;
    i {
      font-size: 18px;
      color: #4095e5;
      display: inline-block;
      margin-right: 5px;
    }
  }
}
.seek_content {
  .el-divider {
    background-color: #4095e5;
  }
  .el-divider__text {
    color: #4095e5;
  }
  ::v-deep .el-input {
    width: 250px;
  }
  .form-row {
    padding-left: 95px;
  }
}
.record_border {
  border: 1px solid #dcdfe6;
}
.record {
  margin: 20px 0;

  border-radius: 10px;
  padding: 10px;
  .customer_header {
    margin-bottom: 20px;
    .left {
      margin-right: 10px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
      text-align: center;
      i {
        color: #fff;
        font-size: 50px;
        line-height: 80px;
      }
    }
    .off {
      background-color: #4095e5;
    }
    .cus {
      background-color: #eee;
    }
    .offname {
      color: #4095e5;
    }
    .cusname {
      color: #5b6b73;
    }
    .cuscontent {
      color: #333;
      overflow: hidden;
      word-wrap: break-word;
    }
    .user_avatar {
      width: 80px;
      img {
        width: 100%;
        object-fit: cover;
      }
    }
    .right {
      color: #4095e5;
      p {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 20px;
      }
      span {
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
  .offname {
    color: #4095e5;
  }
  .cuscontent {
    color: #333;
    overflow: hidden;
    word-wrap: break-word;
  }
}
.file {
  .down-icon {
    margin-left: 10px;
    color: #1890ff;
  }
  .file-list {
    margin: 0 10px;
    padding: 0 5px;
    box-sizing: border-box;
    border-radius: 3px;
    display: flex;
    align-items: center;
    cursor: pointer;
    display: flex;
    i {
      font-size: 20px;
    }
    span {
      display: inline-block;
      font-size: 12px;
      margin-left: 5px;
    }
    .right {
      font-size: 12px;
      padding: 0 5px;
      border: 1px solid #4095e5;
      text-align: center;
      margin-left: 30px;
      border-radius: 6px;
      height: 26px;
      line-height: 26px;
      box-sizing: border-box;
      opacity: 0;
    }
  }
  .file-list:hover {
    background: rgb(243, 246, 249);
    color: #4095e5;
    .right {
      opacity: 1;
    }
  }
}
</style>
